<template>
	<div class="tongxing-wrap">
		<div class="chart-title">山东省金融资产管理有限公司</div>
		<div class="chart-title">股权分红情况</div>
		<div class="tongxing-chart" ref="chart" @click="openPopup"></div>

		<!-- 内联弹窗 -->
		<div
			class="tongxing-popup dashboard-chart-popup dashboard-chart-popup--medium"
			v-if="popupVisible"
			v-append-to-body
		>
			<div class="popup-head">
				<div class="popup-dot"></div>
				<span class="popup-head-text">股权收益明细</span>
				<el-button @click="popupVisible = false" type="text" icon="el-icon-circle-close" />
			</div>
			<div class="popup-company">山东省金融资产管理有限公司股权分红情况</div>
			<div class="popup-sub">被投资方：{{ company }}</div>
			<el-table :data="records" stripe :border="false"
				style="width:100%;background-color:#071a52;"
				height="240">
				<el-table-column prop="year" label="年份" width="90" align="center" />
				<el-table-column prop="income" label="投资收益（万元）" align="center" />
			</el-table>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import apis from '@/http/apis';
	import { mergeGovTooltip } from './gov-chart-tooltip';
	import { mapManagedGroupIncomeRecords } from './tongxing-changtou-data';

	export default {
		name: 'TongxingChangtouShouyi',
		data() {
			return {
				chart: null,
				popupVisible: false,
				company: '山东省金融资产管理股份有限公司',
				records: [],
			};
		},
		created() {
			this.fetchData();
		},
		mounted() {
			window.addEventListener('resize', this.handleResize);
		},
		beforeDestroy() {
			this.unbindChartClick();
			if (this.chart) {
				this.chart.dispose();
				this.chart = null;
			}
			window.removeEventListener('resize', this.handleResize);
		},
		methods: {
			emitIncomeUpdated() {
				if (this.$bus) {
					this.$bus.$emit('tongxing-income-updated', this.records);
				}
			},

			openPopup() {
				this.popupVisible = true;
				if (this.$bus) {
					this.$bus.$emit('close-map-marker');
					this.emitIncomeUpdated();
				}
			},

			unbindChartClick() {
				if (!this.chart) return;
				this.chart.off('click', this.openPopup);
				const zr = this.chart.getZr();
				if (zr) zr.off('click', this.openPopup);
			},

			handleResize() {
				if (this.chart) this.chart.resize();
			},

			fetchData() {
				apis.managedGroupEquityIncomeDetail()
					.then((res) => {
						const list = res && res.data && res.data.list ? res.data.list : [];
						this.records = mapManagedGroupIncomeRecords(list);
						this.emitIncomeUpdated();
						this.initChart();
					})
					.catch((err) => {
						console.error('代管集团投资股权收益接口请求失败', err);
						this.records = [];
						this.emitIncomeUpdated();
						this.initChart();
					});
			},

			initChart() {
				if (this.chart) {
					this.unbindChartClick();
					this.chart.dispose();
				}
				this.chart = echarts.init(this.$refs.chart);

				const years = this.records.map(item => String(item.year).replace('年', ''));
				const values = this.records.map(item => Number(item.income) || 0);
				const maxValue = values.reduce((max, val) => Math.max(max, val), 0);
				const yMax = maxValue > 0 ? Math.ceil(maxValue * 1.15) : undefined;

				const option = {
					grid: {
						left: '2%',
						right: '4%',
						top: '20%',
						bottom: '4%',
						containLabel: true,
					},
					tooltip: mergeGovTooltip({
						trigger: 'axis',
						backgroundColor: 'rgba(0,20,60,0.92)',
						borderColor: '#0075ff',
						borderWidth: 1,
						textStyle: { color: '#cce8ff', fontSize: 11 },
						formatter(params) {
							return `${params[0].axisValue}年<br/>收益：${params[0].value} 万元`;
						},
					}),
					xAxis: {
						type: 'category',
						data: years,
						boundaryGap: false,
						axisLabel: { color: '#cce8ff', fontSize: 10 },
						axisLine: { lineStyle: { color: '#1a4a8a' } },
						axisTick: { show: false },
					},
					yAxis: {
						type: 'value',
						max: yMax,
						name: '万元',
						nameTextStyle: { color: '#8ab4d4', fontSize: 10, padding: [0, 0, 0, -10] },
						axisLabel: { color: '#8ab4d4', fontSize: 10 },
						splitLine: { lineStyle: { color: 'rgba(255,255,255,0.08)' } },
						axisLine: { show: false },
					},
					series: [
						{
							name: '长投收益',
							type: 'line',
							smooth: true,
							triggerEvent: true,
							cursor: 'pointer',
							symbol: 'circle',
							symbolSize: 8,
							data: values,
							lineStyle: {
								color: '#0fb36e',
								width: 2,
							},
							itemStyle: {
								color: '#0fb36e',
								borderColor: '#fff',
								borderWidth: 1,
							},
							areaStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{ offset: 0, color: 'rgba(15, 179, 110, 0.45)' },
									{ offset: 1, color: 'rgba(15, 179, 110, 0.02)' },
								]),
							},
							label: {
								show: true,
								position: 'top',
								color: '#fcf883',
								fontSize: 10,
								formatter(params) {
									return params.value;
								},
							},
						},
					],
				};
				this.chart.setOption(option);
				this.chart.on('click', this.openPopup);
				this.chart.getZr().on('click', this.openPopup);
			},
		},
	};
</script>

<style scoped>
	.tongxing-wrap {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		overflow: visible;
	}

	.chart-title {
		font-size: 12px;
		color: #fcf883;
		text-align: center;
		padding: 3px 0 0;
		letter-spacing: 1px;
		flex-shrink: 0;
	}

	.tongxing-chart {
		flex: 1;
		min-height: 0;
		cursor: pointer;
		overflow: visible;
	}

	/* 弹窗定位见 chart-popup.scss（dashboard-chart-popup） */

	.popup-head {
		margin: 10px;
		color: #ffffff;
		font-size: 14px;
		font-weight: 600;
		display: flex;
		align-items: center;
		gap: 5px;
		position: relative;
	}

	.popup-dot {
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background-color: #fcf883;
		flex-shrink: 0;
	}

	.popup-head-text {
		flex: 1;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.popup-company {
		margin: 0 10px 4px;
		font-size: 13px;
		color: #e8f4ff;
		font-weight: 600;
	}

	.popup-sub {
		margin: 0 10px 8px;
		font-size: 12px;
		color: #8ab4d4;
	}

	.tongxing-popup ::v-deep .el-icon-circle-close {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		font-size: 20px;
		color: #fff;
	}

	.tongxing-popup ::v-deep .el-table tr {
		color: #fff !important;
		background-color: #071a52 !important;
	}

	.tongxing-popup ::v-deep .el-table th.el-table__cell {
		color: #fff !important;
		background-color: #3c4a77 !important;
	}

	.tongxing-popup ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
		background-color: #0d2569 !important;
	}

	.tongxing-popup ::v-deep .el-table__cell {
		padding: 5px 0 !important;
		font-size: 12px;
		border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
		border-bottom: none !important;
	}

	.tongxing-popup ::v-deep .el-table::before {
		height: 0;
	}
</style>
